import React from 'react';
import LocationTemplate from './LocationTemplate';

const NagsHeadPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Nags Head"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27959"]}
      latitude={35.9579}
      longitude={-75.6240}
      population={2757}
      historicalFact="Named after the Outer Banks legend where horses with lanterns lured ships to shore; established resort town since 1830s."
      nearbyTowns={[
        "Kill Devil Hills, NC",
        "Manteo, NC",
        "Kitty Hawk, NC",
        "Duck, NC",
        "Southern Shores, NC",
        "Rodanthe, NC",
        "Dare Mainland, NC",
        "Elizabeth City, NC"
      ]}
    />
  );
};

export default NagsHeadPage;